export const bannerModalGenerateLinkTranslationKeys = {
  afftrackTypeHere: 'afftrack.type-here',

  promoModalButtonActivateOffer: 'promo.modal-button-activate-offer',
  promoModalButtonAcceptRules: 'offers.page-offer-tab-activation-accordion-accept-rules-title',
  promoModalButtonCopyLink: 'promo.modal-button-copy-link',
}
